import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthUseCaseService } from '../../../auth/application/auth-use-case.service';
import {
  ModulesAndPermissionsOfUser,
  UserModel,
} from '@domain/auth/domain/User.model';

export const userHasPlatformsAccessGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const authUseCaseService = inject(AuthUseCaseService);

  const waitForUserPermissions = async (): Promise<
    ModulesAndPermissionsOfUser[] | null
  > => {
    let permissions = authUseCaseService.user()?.permissions;
    if (permissions) return permissions;

    const userStoragedRaw = localStorage.getItem('user');
    if (userStoragedRaw) {
      try {
        const userStoraged = JSON.parse(userStoragedRaw) as UserModel;
        permissions = userStoraged?.permissions ?? null;
        if (permissions) return permissions;
      } catch (e) {
        // Ignore parse errors and continue waiting for service state.
      }
    }

    while (!permissions) {
      await new Promise((resolve) => setTimeout(resolve, 10));
      permissions = authUseCaseService.user()?.permissions;
    }

    return permissions;
  };

  const userPermissions = await waitForUserPermissions();
  const moduleNameList =
    userPermissions?.map((module) => module.moduleName?.toLowerCase()) ?? [];

  const hasPlatformsAccess = moduleNameList.some((moduleName) =>
    ['systems', 'security', 'administrators'].includes(moduleName ?? '')
  );

  if (hasPlatformsAccess) return true;

  router.navigate(['/main']);
  return false;
};